import React from "react";
import LocomotiveScroll from "locomotive-scroll";
import "locomotive-scroll/dist/locomotive-scroll.css";

import Landing from "./Landing/Landing";
import Work from "./Work/Work";
import About from "./About/About";
import Footer from "./Footer/Footer";

import "./Wrapper.scss";
import Header from "./Header/Header";

export default class Wrapper extends React.Component {
  scrollRef = React.createRef();

  componentDidMount() {
    this.scroll = new LocomotiveScroll({
      el: this.scrollRef.current,
      smooth: true,
      lerp: 0.1,
    });

    window.locoScroll = this.scroll; // <-- very important!

    // Wait a bit and update scroll calculations
    window.addEventListener("load", () => {
      this.scroll.update();
    });

    // Extra fallback update after a short delay
    setTimeout(() => this.scroll.update(), 1000);
  }
  componentDidUpdate() {
    if (this.scroll) {
      this.scroll.update();
    }
  }

  componentWillUnmount() {
    if (this.scroll) {
      this.scroll.destroy();
    }
  }

  render() {
    return (
      <div
        className="wrapper bg-black"
        data-scroll-container
        ref={this.scrollRef}
      >
        <Header />
        <div className="wrapper-body" data-scroll-section>
          <Landing />
          <Work />
          <About />
        </div>
        <Footer />
      </div>
    );
  }
}
